  import Swiper from 'swiper/bundle';
  const swiper = new Swiper('.home-slider', {
    // Optional parameters
    // direction: 'vertical',
    autoplay: {
      delay: 3000,
    },
    slidesPerView: 1,
    spaceBetween: 30,
    loop: true,
    lazy: true,
    // Navigation arrows
    navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
    },

});

const newProducts = new Swiper('.home-new-products-slider', {
    // Optional parameters
    // direction: 'vertical',
    autoplay: {
      delay: 3000,
    },
    lazy: true,
    slidesPerView: 5,
    spaceBetween: 20,
    loop: true,
    breakpoints: {
        "@0.00": {
          slidesPerView: 1,
          spaceBetween: 10,
        },
        "@0.75": {
          slidesPerView: 2,
          spaceBetween: 20,
        },
        "@1.00": {
          slidesPerView: 3,
          spaceBetween: 30,
        },
        "@1.50": {
          slidesPerView: 5,
          spaceBetween: 20,
        },
      },

    // Navigation arrows
    navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
    },

});


const brands = new Swiper('.home-brands-slider', {
    // Optional parameters
    // direction: 'vertical',
    autoplay: {
      delay: 3000,
    },
    lazy: true,
    slidesPerView: 6,
    spaceBetween: 30,
    loop: true,
    breakpoints: {
        "@0.00": {
          slidesPerView: 2,
          spaceBetween: 10,
        },
        "@0.75": {
          slidesPerView: 2,
          spaceBetween: 20,
        },
        "@1.00": {
          slidesPerView: 3,
          spaceBetween: 30,
        },
        "@1.50": {
          slidesPerView: 5,
          spaceBetween: 20,
        },
      },


});


// var productThumbs = new Swiper(".product-thumbs", {
//       spaceBetween: 10,
//       lazy: true,
//       slidesPerView: 4,
//       freeMode: true,
//       watchSlidesProgress: true,
//     });
//
// var productSlider = new Swiper(".product-slider", {
//       spaceBetween: 10,
//       lazy: true,
//       navigation: {
//         nextEl: ".swiper-button-next",
//         prevEl: ".swiper-button-prev",
//       },
//       thumbs: {
//         swiper: productThumbs,
//       },
//     });

var galleryThumbs = new Swiper('.product-thumbs', {
  spaceBetween: 10,
  slidesPerView: 4,
  freeMode: true,
  watchSlidesVisibility: true,
  watchSlidesProgress: true
});
var galleryTop = new Swiper('.product-slider', {
  spaceBetween: 10,
  grabCursor: true,
  thumbs: {
    swiper: galleryThumbs
  }
});


const relatedProducts = new Swiper('.related-products-slider', {
    // Optional parameters
    // direction: 'vertical',
    autoplay: {
      delay: 3000,
    },
    lazy: true,
    slidesPerView: 5,
    spaceBetween: 20,
    loop: true,
    breakpoints: {
        "@0.00": {
          slidesPerView: 1,
          spaceBetween: 10,
        },
        "@0.75": {
          slidesPerView: 2,
          spaceBetween: 20,
        },
        "@1.00": {
          slidesPerView: 3,
          spaceBetween: 30,
        },
        "@1.50": {
          slidesPerView: 5,
          spaceBetween: 20,
        },
      },

    // Navigation arrows
    navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
    },

});
